import {
  departmentHealthActionPriority,
  departmentHealthActionType,
  orangeColors,
} from '../../../../../layouts/theme/designSystem';
import type {
  DepartmentHealthActionPriority,
  DepartmentHealthActionType,
} from '../../types/DepartmentHealthTypes';

export type DepartmentHealthActionVisualStyles = {
  iconBg: string;
  iconColor: string;
  iconBorder: string;
};

const actionTypeStyles: Record<DepartmentHealthActionType, DepartmentHealthActionVisualStyles> = {
  skill_training: departmentHealthActionType.skillTraining,
  single_point_of_failure: departmentHealthActionType.singlePointOfFailure,
  redeployment_review: departmentHealthActionType.redeploymentReview,
  development_plans: departmentHealthActionType.developmentPlans,
  data_quality: departmentHealthActionType.dataQuality,
  all_clear: departmentHealthActionType.allClear,
};

export const getDepartmentHealthActionItemStyles = (
  actionType: DepartmentHealthActionType,
): DepartmentHealthActionVisualStyles => actionTypeStyles[actionType];

export const getDepartmentHealthActionPriorityStyles = (priority: DepartmentHealthActionPriority) =>
  departmentHealthActionPriority[priority];

export const departmentHealthActionCardBg = orangeColors[5];
